/* global BX, bitrix_sessid, FormUtils */

(function () {
    if (typeof BX === 'undefined' || typeof FormUtils === 'undefined') return;

    const modalId = 'order-service-modal-overlay';
    const closeBtnId = 'order-service-form-header-btn';
    const submitBtn = document.getElementById('order-service-submit-btn');
    const commonErrorsBlock = document.getElementById('order-service-form-common-errors');
    const captchaContainerId = 'captcha-container-order-service';
    const containerSelector = '';

    const fullname = document.getElementById('fullname-order-service');
    const phone = document.getElementById('phone-order-service');
    const email = document.getElementById('email-order-service');
    const message = document.getElementById('message-order-service');

    const nameService = document.getElementById('name-service');
    const service = document.getElementById('service-order-service');

    if (!nameService) return;

    service.value = nameService.value;

    if (!document.getElementById(modalId) || !submitBtn) return;

    FormUtils.setupPhoneMask(phone);

    const initCaptcha = () => FormUtils.initCaptcha(captchaContainerId);
    const resetCaptcha = () => FormUtils.resetCaptcha();

    const clearFields = () => {
        fullname.value = '';
        phone.value = '';
        email.value = '';
        message.value = '';
    };

    const hideErrors = () => {
        FormUtils.clearFieldErrors(containerSelector);
        FormUtils.hideCommonError(commonErrorsBlock);
    };

    const validate = () => {
        let isValid = true;
        hideErrors();

        if (!FormUtils.validateRequired(fullname.value)) {
            FormUtils.showFieldError(fullname, '*Обязательное поле');
            isValid = false;
        }

        const phoneDigits = phone.value.replace(/\D/g, '');
        if (!FormUtils.validateRequired(phone.value)) {
            FormUtils.showFieldError(phone, '*Обязательное поле');
            isValid = false;
        } else if (!FormUtils.validatePhoneDigits(phoneDigits)) {
            FormUtils.showFieldError(phone, '*Введите корректный номер телефона (не менее 10 цифр)');
            isValid = false;
        }

        if (!FormUtils.validateRequired(email.value)) {
            FormUtils.showFieldError(email, '*Обязательное поле');
            isValid = false;
        } else if (!FormUtils.validateEmail(email.value)) {
            FormUtils.showFieldError(email, '*Введите корректный E-mail');
            isValid = false;
        }

        if (!FormUtils.validateRequired(service.value)) {
            FormUtils.showFieldError(service, '*Обязательное поле');
            isValid = false;
        }

        const captchaToken = document.querySelector(`#${captchaContainerId} input[name="smart-token"]`);
        if (!captchaToken || !captchaToken.value) {
            FormUtils.showCommonError(commonErrorsBlock, 'Пожалуйста, подтвердите, что вы не робот');
            isValid = false;
        }

        if (!isValid) FormUtils.scrollToFirstError(containerSelector, commonErrorsBlock);
        return isValid;
    };

    const send = async () => {
        if (!validate()) return;

        const captchaToken = document.querySelector(`#${captchaContainerId} input[name="smart-token"]`);
        const token =
            typeof bitrix_sessid === 'function' ? bitrix_sessid() : BX.bitrix_sessid ? BX.bitrix_sessid() : '';

        const payload = {
            fullname: fullname.value,
            phone: phone.value,
            email: email.value,
            service: service.value,
            message: message.value,
            smart_token: captchaToken ? captchaToken.value : '',
        };

        if (submitBtn) submitBtn.disabled = true;

        try {
            await FormUtils.sendFormData({
                url: '/api/v1/form/order-service',
                payload,
                headers: {
                    'Session-Id': token,
                    'X-Requested-With': 'XMLHttpRequest',
                },
                submitBtn,
                commonErrorsBlock,
                containerSelector,
                onSuccess: (result) => {
                    alert(result.message || 'Спасибо! Ваше сообщение отправлено.');
                    close();
                },
                onFieldError: (field, msg) => {
                    const el = document.getElementById(field);
                    if (el) FormUtils.showFieldError(el, msg);
                },
            });
        } finally {
            if (submitBtn) submitBtn.disabled = false;
        }
    };

    const open = () => {
        document.getElementById(modalId).style.display = 'flex';
        document.body.style.overflow = 'hidden';
        hideErrors();
        initCaptcha();
        resetCaptcha();
    };

    const close = () => {
        document.getElementById(modalId).style.display = 'none';
        document.body.style.overflow = '';
        clearFields();
        hideErrors();
        resetCaptcha();
    };

    FormUtils.createModal({
        modalId,
        closeBtnId,
        openBtnClass: '.open-order-service',
        onOpen: open,
        onClose: close,
    });

    submitBtn.addEventListener('click', send);
})();
